module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <navbar caption=\"'Silverplate'\"></navbar>\n  <jumbotron body=\"'Your modern code boilerplate'\"></jumbotron>\n  <sidenav></sidenav>\n  <div ui-view></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/app.html
 ** module id = 58
 ** module chunks = 0
 **/